import { useState, useEffect } from "react";
import { searchMembers } from "../api/members";

/**
 * Debounced пошук членів компанії.
 * @param {string} query - Пошуковий запит
 * @param {Set} excludeIds - ID користувачів яких виключити з результатів
 */
export function useMemberSearch(query, excludeIds = new Set()) {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (!query.trim()) {
      setSuggestions([]);
      return;
    }
    const timer = setTimeout(async () => {
      try {
        const data = await searchMembers(query);
        const members = (data.members || []).filter(m => !excludeIds.has(m.id));
        setSuggestions(members);
      } catch {
        setSuggestions([]);
      }
    }, 300);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return suggestions;
}
